import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import GroupIdentityTableHead from '../../components/molecules/GroupIdentityTableHead';
import GroupIdentityTableBody from '../../components/molecules/GroupIdentityTableBody';
import GroupIdentityRegister from './GroupIdentityRegister';
import GroupIdentityApproval from './GroupIdentityApproval';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import { getIdentities, editIdentityStatus } from '../../actions/Identity';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      identities: state.identities.identities,
      totalCount: state.identities.totalCount,
      offset: state.identities.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getIdentities, editIdentityStatus },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openRegisterModal', 'updateOpenRegisterModal', false),
  withState('openApprovalModal', 'updateOpenApprovalModal', false),
  withState(
    'openApprovalConfirmModal',
    'updateOpenApprovalConfirmModal',
    false
  ),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('page', 'setPage', 0),
  withState('detail', 'setDetail', {}),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    roles,
    identities,
    searchKey,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    openRegisterModal,
    updateOpenRegisterModal,
    openApprovalModal,
    updateOpenApprovalModal,
    openApprovalConfirmModal,
    updateOpenApprovalConfirmModal,
    rowsPerPage,
    handleChangeRowsPerPage,
    targetRowId,
    setTargetRowId,
    detail,
    setDetail
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    const registerOpenAction = params => {
      updateOpenRegisterModal(true);
      setTargetRowId(params.id);
    };
    const confirmOpenAction = async params => {
      setDetail(params);
      updateOpenApprovalModal(true);
    };
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GroupIdentityTableHead roles={roles} />
            <GroupIdentityTableBody
              identities={identities}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              registerOpenAction={registerOpenAction}
              confirmOpenAction={confirmOpenAction}
              updateOpenRegisterModal={updateOpenRegisterModal}
              updateOpenConfirmModal={updateOpenApprovalModal}
              setTargetRowId={setTargetRowId}
              roles={roles}
            />
          </Table>
        </div>
        {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
          <div>
            <ExPagination
              searchResults={identities}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalCount}
              offset={offset}
              selectedPage={selectedPage}
            />
          </div>
        )}
        <Modal open={openRegisterModal}>
          <GroupIdentityRegister
            updateOpenRegisterModal={updateOpenRegisterModal}
            searchKey={searchKey}
            targetRowId={targetRowId}
          />
        </Modal>
        <Modal open={openApprovalModal}>
          <GroupIdentityApproval
            updateOpenApprovalModal={updateOpenApprovalModal}
            openApprovalConfirmModal={openApprovalConfirmModal}
            updateOpenApprovalConfirmModal={updateOpenApprovalConfirmModal}
            detail={detail}
            targetRowId={targetRowId}
            searchKey={searchKey}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
